import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';

import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { getPayrolls } from '../../actions/payrollRegister';
import * as StatusCode from '../../scripts/StatusCode';
import { formatDate, toDisplayDecimal, unique_values, addPad } from '../../utils'
import PayrollDetail from './PayrollDetail'
import PdfWage from '../wage/PdfWage';
import styles from '../../styles/payrollRegister.module.css';

const useStyles = makeStyles((theme) => ({
    spanLabel: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    spanValue: {
        marginLeft: '5px',
        fontSize: '13px'
    },
    divInfo: {
        marginTop: '0',
        marginLeft: '3px',
        marginRight: '3px',
        marginBottom: '10px',
        borderRadius: '10px',
        boxShadow: '0px 0px 5px 0px #a7a7a7',
        paddingBottom: '10px',
        textAlign: 'left !important'
    },
    divRow: {
        display: 'table',
        '& > span:first-of-type': {
            float: 'left',
            display: 'flex'
        },
        '& > span:nth-child(2)': {
            marginLeft: 'auto',
            float: 'right',
            display: 'flex'
        }
    },
    divHour: {
        width: '100%',
        paddingTop: '5px',
        paddingBottom: '5px',
        paddingLeft: '10px',
        paddingRight: '10px',
        borderBottom: '1px solid var(--color9)',
        fontSize: '16px',
        borderTopLeftRadius: '9px',
        borderTopRightRadius: '9px',
        backgroundColor: 'var(--color1)',
        color: 'var(--color2)',
        display: 'inline-flex',
        alignItems: 'center'
    },
    divTabMaster: {
        marginTop: `10px`,
        paddingLeft: '10px',
        paddingRight: '10px'
    },
    divTab: {
        display: 'table',
        width: '100%'
    }
}));

export function PayrollRegisterList(props) {

    const classes = useStyles();

    const [data, setData] = useState(null);
    const [expanded, setExpanded] = useState(false);
    const [lastPay, setLastPay] = useState(null);
    const [open, setOpen] = useState(false);
    const [openPdf, setOpenPdf] = useState(false);
    const [title, setTitle] = useState('');
    const [fileContent, setFileContent] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [dataRow, setDataRow] = useState(null);

    const alertRef = useRef(null);

    useEffect(() => {

        let loadList = async () => {

            var response = await getPayrolls();

            if (response?.status == StatusCode.STATUS_OK) {

                let sortedData = response.data?.sort(function (a, b) {
                    return new Date(b.payDate) - new Date(a.payDate);
                });

                let dict = null;

                if (sortedData != null && sortedData.length > 0) {
                    setLastPay(sortedData.shift());

                    dict = {};
                    let listYears = unique_values(sortedData, 'year');

                    listYears.forEach((year) => {
                        dict[year] = sortedData.filter(item => {
                            return item.year === year;
                        });
                    });

                    setExpanded(Math.max(...listYears).toString());
                }

                setData(dict);

                setTimeout(() => {//Wait until load page complete 
                    setIsActive(false);
                }, 2500);

            } else {
                showMessageError(i18next.t('error:generic-error'));
            }
        }

        loadList();

    }, []);

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const handleClick = (obj) => {
        setDataRow(obj);
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpenPdf = (title, fileContent) => {
        setTitle(title);
        setFileContent(fileContent);
        setOpenPdf(true);
    }

    const handleClosePdf = () => {
        setOpenPdf(false);
    };

    const handleAccordion = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div className={styles.konekCard}>
            <LoadingOverlay
                active={isActive}
                spinner={<BeatLoader />}
                text={i18next.t('common:loading')}
            >
                {lastPay !== null &&
                    <div className={classes.divInfo}>
                        <div className={`${classes.divRow} ${classes.divHour}`} onClick={() => { handleClick(lastPay); }}>
                            <span>{`${i18next.t('payrollRegister:list.lastPayStatement')}`}</span>
                            <span style={{ fontSize: "20px" }} >{toDisplayDecimal(lastPay.netPay, 2, true)}</span>
                        </div>

                        <div className={classes.divTabMaster}>
                            <div className={classes.divTab}>
                                <div onClick={() => { handleClick(lastPay); }}>
                                    <div>
                                        <span className={classes.spanLabel}>{`${i18next.t('payrollRegister:list.payDate')}${i18next.t('common:labelSeparator')}`}</span>
                                        <span className={classes.spanValue}>{formatDate(lastPay.payDate, 'date')}</span>
                                    </div>
                                    <div>
                                        <span className={classes.spanLabel}>{`${i18next.t('payrollRegister:list.grossAmount')}${i18next.t('common:labelSeparator')}`}</span>
                                        <span className={classes.spanValue}>{toDisplayDecimal(lastPay.grossPay, 2, true)}</span>
                                    </div>

                                    <div>
                                        <span className={classes.spanLabel}>{`${i18next.t('payrollRegister:list.targetPeriod')}${i18next.t('common:labelSeparator')}`}</span>
                                        <span className={classes.spanValue}>{`${lastPay.year}-${addPad(lastPay.period)}`}</span>
                                    </div>
                                    <div>
                                        <span className={classes.spanLabel}>{`${i18next.t('payrollRegister:list.payPeriod')}${i18next.t('common:labelSeparator')}`}</span>
                                        <span className={classes.spanValue}>{`${i18next.t('common:from')} ${formatDate(lastPay.startDate, 'date')} ${i18next.t('common:to')} ${formatDate(lastPay.endDate, 'date')}`}</span>
                                    </div>
                                    <div>
                                        <span className={classes.spanLabel}>{`${i18next.t('payrollRegister:list.typePayment')}${i18next.t('common:labelSeparator')}`}</span>
                                        <span className={classes.spanValue}>{lastPay.isDirectDepositMode == 'O' ? `${i18next.t('payrollRegister:list.directDeposit')}` : `${i18next.t('payrollRegister:list.cheque')}`}</span>
                                    </div>
                                </div>

                                {lastPay.fileContentBase64 != null &&
                                    <div style={{ marginTop: `15px` }}>
                                        <Divider style={{ height: '2px', marginBottom: `10px`, backgroundColor: 'rgb(92 127 185)' }} />
                                        <span className={classes.spanLabel}><PictureAsPdfIcon /></span>
                                        <span className={classes.spanValue}>{lastPay.title}</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }

                {data !== null && Object.keys(data).sort(function (a, b) {
                    return b - a;
                }).map((year, idx) =>
                    <React.Fragment key={idx}>
                        <Accordion expanded={expanded === year} onChange={handleAccordion(year)}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon className={styles.iconAccordion} />}
                                aria-controls={`panel${idx}-content`}
                                id={`panel${idx}-header`}
                                className={styles.accordionSummary}
                            >
                                <div>{`${year}`}</div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div id={`employmentRecord${idx}`}>
                                    <List>
                                        {data[year].map((obj, index) =>
                                            <React.Fragment key={`${year}-${index}`}>
                                                <div className="listItem">
                                                    <ListItem key={`${year}-${index}`} button onClick={() => handleClick(obj)}>
                                                        <ListItemText disableTypography={true} primary={
                                                            <React.Fragment>
                                                                <div>
                                                                    <span className={classes.spanLabel}>{`${i18next.t('payrollRegister:list.payDate')}${i18next.t('common:labelSeparator')}`}</span>
                                                                    <span className={classes.spanValue}>{formatDate(obj.payDate, 'date')}</span>
                                                                </div>
                                                                <div>
                                                                    <span className={classes.spanLabel}>{`${i18next.t('payrollRegister:list.netPay')}${i18next.t('common:labelSeparator')}`}</span>
                                                                    <span className={classes.spanValue}>{toDisplayDecimal(obj.netPay, 2, true)}</span>
                                                                </div>
                                                            </React.Fragment>
                                                        } />
                                                    </ListItem>
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </List>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </React.Fragment>
                )}

                {dataRow != null && <PayrollDetail data={dataRow} open={open} onClose={handleClose} handleOpenPdf={handleOpenPdf} />}

                {fileContent !== null &&
                    <PdfWage
                        open={openPdf}
                        onClose={handleClosePdf}
                        pdfData={fileContent}
                        filename="wage.pdf"
                        required={false}
                        title={title} />
                }
            </LoadingOverlay>
        </div>
    );
}

export default withNamespaces(['menu', 'payrollRegister', 'common', 'error'], { wait: true })(PayrollRegisterList);